import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

// Import your shared components
import { TextInput } from "./TextInput";
import Button from "../../../../../../../components/button";
import {
  ButtonSize,
  ButtonVariant,
} from "../../../../../../../components/button/types";

interface TargetRoleFormData {
  targetRole: string;
}

interface TargetRoleStepProps {
  onConfirm: (targetRole: string) => void;
  isLoading: boolean;
}

export const TargetRoleStep: React.FC<TargetRoleStepProps> = ({
  onConfirm,
  isLoading,
}) => {
  const { t } = useTranslation("cvEditor");

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<TargetRoleFormData>({
    mode: "onChange",
    defaultValues: {
      targetRole: "",
    },
  });

  // react-hook-form's handleSubmit will only call onConfirm if validation passes
  const onSubmit = (data: TargetRoleFormData) => {
    onConfirm(data.targetRole);
  };

  return (
    <div className="p-6 flex flex-col h-full">
      <div className="flex-grow overflow-y-auto pr-2 -mr-2">
        <h3 className="text-lg font-medium text-gray-900 mb-1">
          {t("targetRoleStep.title")}
        </h3>
        <p className="text-gray-600 mb-6">{t("targetRoleStep.description")}</p>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="targetRole"
            control={control}
            rules={{ required: t("targetRoleStep.errors.required") as string }}
            render={({ field }) => (
              <TextInput
                label={t("targetRoleStep.label")}
                value={field.value}
                onChange={field.onChange}
                placeholder={
                  t("targetRoleStep.placeholder") ||
                  "need to be added to the statics"
                }
                required
                error={!!errors.targetRole}
                helperText={errors.targetRole?.message}
              />
            )}
          />
        </form>
      </div>

      <div className="flex-shrink-0 mt-auto pt-4 border-t border-gray-200">
        <div className="flex justify-end">
          <Button
            type="button"
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SMALL}
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid || isLoading}
            isLoading={isLoading}
            className="w-full"
          >
            {t("common.startInterview")}
          </Button>
        </div>
      </div>
    </div>
  );
};
